import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  ins_has_medicare: Yup.boolean(),
  ins_has_medicaid: Yup.boolean(),
  ins_has_private: Yup.boolean(),
  ins_has_cobra: Yup.boolean(),
  ins_comments: Yup.string().max(
    500,
    'Comments must be less than 500 characters'
  ),
  ins_company: Yup.string().when(['ins_has_private', 'ins_has_cobra'], {
    is: (ins_has_private: boolean, ins_has_cobra: boolean) =>
      ins_has_private || ins_has_cobra,
    then: (schema) => schema.required('Insurance company is required'),
    otherwise: (schema) => schema,
  }),
  ins_premium: Yup.number()
    .nullable()
    .when('noCopay', {
      is: false,
      then: (schema) =>
        schema
          .required('Insurance premium is required')
          .min(0, 'Insurance premium must be greater than or equal to 0'),
      otherwise: (schema) => schema.nullable(),
    }),
  ins_cobra_months: Yup.number()
    .nullable()
    .when('ins_has_cobra', {
      is: true,
      then: (schema) =>
        schema
          .required('Cobra number of months is required')
          .min(1, 'Must be at least 1 month'),
      otherwise: (schema) => schema.nullable(),
    }),
  ins_cobra_amount: Yup.number()
    .nullable()
    .when('ins_has_cobra', {
      is: true,
      then: (schema) =>
        schema
          .required('Cobra amount is required')
          .min(0, 'Cobra amount must be greater than or equal to 0'),
      otherwise: (schema) => schema.nullable(),
    }),
  ins_has_none: Yup.boolean(),
  ins_unknown: Yup.boolean(),
  noCopay: Yup.boolean(),
});

export { validationSchema };